import Ajax from 'global/od/Ajax';

const voucherFormRequest = (data, url = {}) =>
	Ajax({
		url,
		method: 'POST',
		dataType: 'html',
		data,
	});

export { voucherFormRequest as default };
